export default "__VITE_ASSET__X6R2BrYb__"